/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Enum_Favorite_Type, ResourceEntity } from '@/graphql/generated/graphql';
import { useKnowledgeHubStore } from '@/pages/knowledge-hub/page/store/useKnowledgeHubStore';
import { useEffect } from 'react';
import { Loading } from './loading';
import { useNavigate } from 'react-router-dom';
import FavoriteButton from '@/components/Favorite/FavoriteButton';

export default function Latests() {
  const { loadLatests, latestArticles, latestGuides, latestTopTips, loadingLatestsByType } = useKnowledgeHubStore();
  const navigate = useNavigate();

  useEffect(() => {
    loadLatests();
  }, [loadLatests]);

  if (loadingLatestsByType) return <Loading />;

  const title = (title: string) => {
    return <h2 className=" font-larken !text-sh-sm !font-normal">{title}</h2>;
  };

  const onClickCard = (slug?: string) => {
    navigate(`/knowledge-hub/slug/${slug}`);
  };
  const renderCard = (resource: ResourceEntity) => {
    return (
      <div
        key={resource.id}
        className=" h-[140px] cursor-pointer rounded-2xl border-[3px] border-[#C0D7F2] p-5 hover:bg-primary-500">
        <div className="flex items-start justify-between">
          <h4
            className=" line-clamp-2 font-larken text-sh-18-24 "
            onClick={() => onClickCard(resource.attributes?.slug)}>
            {resource.attributes?.title}
          </h4>
          <FavoriteButton
            relationId={resource?.id?.toString() || ''}
            metadata={resource}
            type={Enum_Favorite_Type.Resource}
          />
        </div>
        <p className=" line-clamp-2 text-sh-xxs" onClick={() => onClickCard(resource.attributes?.slug)}>
          {resource.attributes?.briefDescription}
        </p>
      </div>
    );
  };
  return (
    <>
      <div className="flex flex-col gap-sh-30">
        {title('Latest Articles')}
        {latestArticles.map((article) => renderCard(article as ResourceEntity))}
      </div>
      <div className="flex flex-col gap-sh-30">
        {title('Latest Guides')}
        {latestGuides.map((article) => renderCard(article as ResourceEntity))}
      </div>
      <div className="flex flex-col gap-sh-30">
        {title('Latest Top Tips')}
        {latestTopTips.map((article) => renderCard(article as ResourceEntity))}
      </div>
    </>
  );
}
